import { currentWindowHeight, currentWindowWidth } from '../utils/windowResize';

export function setupGalleries(snapToItems = false) {
    const galleries = Array.from(document.querySelectorAll('.gallery')).filter(x => x.querySelectorAll('.gallery__item').length > 0);

    Array.from(galleries).forEach(gallery => {
        const galleryImages = gallery.querySelectorAll('.gallery__image');
        let imagesTotalWidth;
        let imageCount = 0;

        function imageLoaded(e) {
            imageCount++;
            //imagesTotalWidth = e.currentTarget.offsetWidth();
            checkImages();
        }

        function imageError(e) {
            imageCount++;
            //imagesTotalWidth = e.currentTarget.offsetWidth();
            checkImages();
        }

        Array.from(galleryImages).forEach(image => {
            if (image.complete) {
                imageCount++;
                checkImages();
            } else {
                image.addEventListener('load', imageLoaded);
                image.addEventListener('error', imageError);
            }
        });

        function checkImages() {
            if (imageCount == galleryImages.length) {
                loadGallery();
            }
        }

        function loadGallery() {
            const maxPxPrSecond = 10000;
            const galleryWrap = gallery.querySelector('.gallery__list-wrap');
            const galleryList = gallery.querySelector('.gallery__list');
            const galleryItems = gallery.querySelectorAll('.gallery__item');
            const progressBar = gallery.querySelector('.gallery__slider-bar');
            const maxTranslate = 0;
            const minTranslate = galleryWrap.offsetWidth - galleryList.scrollWidth;

            let listAnimation = -1;

            gallery.setAttribute('data-max-translate', maxTranslate);
            gallery.setAttribute('data-min-translate', minTranslate);

            let move = false;
            let touch = false;

            // Start y and start x is where whe start touching the screen. Only set once at touchstart and mousedown
            let startX = -1;
            let startY = -1;

            // Updated as we move the mouse (when button is down) or slide the screen
            let moveX = -1;
            let moveY = -1;

            // Used to set the direction - do we need to slide left or right
            let direction = -1;

            // Let's save the distance between startX and moveX here so we know how much to move it around
            let distanceX = -1;

            // This is used for the current move. This + pxMoved is what we want to translate the slider
            let translateX = -1;

            // Lets update this every time we move the slider. We don't want to start from 0 each time
            let pxMoved = 0;

            // Did we move at all? Or just click / touch once. If not we don't want to move at all
            let moved = false;

            // Let's take a look at how much px. we moved pr. second when moving. Maybe we can use that to calculate if we want to slide a bit mmore - and maybe even bounce if we move more than the slider alows.
            let startTime = -1;
            let endTime = -1;
            let time = -1;

            // Let's know if we are currently sliding some extra px
            let animating = false;

            // Array to contain the animations steps
            let animationSteps = [];

            // Only the last part where we bounce back. The rest is in the "getAnimationSteps"
            function getBounceSteps(bouncePx) {
                let lastMove = 0;
                let nextMove = 0;
                let bouncedExtra = 0;

                function getNextBounceMove() {
                    if (lastMove == 0) {
                        nextMove = direction == 'left' ? 5 : -5;
                    } else {
                        nextMove = lastMove * 1.1;
                    }

                    if (direction == 'left') {
                        if ((bouncedExtra + nextMove) > (bouncePx * -1)) {
                            nextMove = (bouncePx * -1) - bouncedExtra;
                        }
                    } else if (direction == 'right') {
                        if ((bouncedExtra + nextMove) < (bouncePx * -1)) {
                            nextMove = (bouncePx * -1) - bouncedExtra;
                        }
                    }

                    lastMove = nextMove;

                    return nextMove;
                }

                if (direction == 'left') {
                    while (bouncedExtra < (bouncePx * -1)) {
                        nextMove = getNextBounceMove(lastMove);
                        bouncedExtra = bouncedExtra + nextMove;

                        animationSteps.push(nextMove);
                    }
                } else if (direction == 'right') {
                    while (bouncedExtra > (bouncePx * -1)) {
                        nextMove = getNextBounceMove(lastMove);
                        bouncedExtra = bouncedExtra + nextMove;

                        animationSteps.push(nextMove);
                    }
                }
            }

            // Get the animtionsteps to animate the move we made - including bounce mvoes (above) if we did it really fast ;-)
            function getAnimationSteps(moveExtra) {
                const maxBounce = gallery.offsetWidth / 3;
                const maxPrFrame = 100;
                animationSteps = [];
                let lastMove = 0;
                let nextMove = 0;
                let movedTotal = 0;
                let bouncePx = 0;
                let bounce = false;

                if (direction == 'left') {
                    if (translateX + moveExtra < minTranslate) {
                        bounce = true;
                    }
                } else if (direction == 'right') {
                    if (translateX + moveExtra > 0) {
                        bounce = true;
                    }
                }

                if (bounce) {
                    if (direction == 'left') {
                        //itemIndex = galleryItems.length - 1;

                        // TODO: When bouncing its the opposite way, so no * -1 here... Remeber in getBounceSteps...
                        if ((pxMoved + moveExtra) < (minTranslate - maxBounce)) {
                            bouncePx = maxBounce * -1;
                        } else {
                            bouncePx = (pxMoved + moveExtra) - minTranslate;
                        }

                        if (pxMoved + moveExtra < minTranslate) {
                            moveExtra = minTranslate - pxMoved;
                            moveExtra = moveExtra + bouncePx;
                        }
                    } else if (direction == 'right') {
                        //itemIndex = 0;

                        if (pxMoved + moveExtra > (maxTranslate + maxBounce)) {
                            bouncePx = maxBounce;
                        } else {
                            bouncePx = (pxMoved + moveExtra);
                        }

                        if (pxMoved + moveExtra > maxTranslate) {
                            moveExtra = maxTranslate - pxMoved;
                            moveExtra = moveExtra + bouncePx;
                        }
                    }

                    //updateNav(itemIndex);
                } else {
                    if (snapToItems) {
                        if (direction == 'left') {
                            const newPosition = (moveExtra + pxMoved) * -1;
                            const newIndex = Math.round((newPosition + itemSnapStart) / itemWidth);

                            let moveTotal = 0;

                            if (newIndex == 0) {
                                moveTotal = 0;
                            } else {
                                if (galleryItems.length - 1 >= newIndex) {
                                    moveTotal = (galleryItems[newIndex].offsetLeft * -1) - 10;
                                }
                            }

                            moveExtra = moveTotal - pxMoved;
                            // = newIndex;

                            //updateNav(itemIndex);
                        } else if (direction == 'right') {
                            const newPosition = (moveExtra + pxMoved) * -1;
                            const newIndex = Math.round((newPosition + itemSnapStart) / itemWidth) - 1;

                            let moveTotal = 0;

                            if (newIndex == 0) {
                                moveTotal = 10;
                            } else {
                                if (galleryItems.length - 1 >= newIndex) {
                                    moveTotal = (galleryItems[newIndex].offsetLeft * -1) + 10;
                                }
                            }

                            moveExtra = moveTotal - pxMoved;
                            //itemIndex = newIndex;

                            //updateNav(itemIndex);
                        }
                    }
                }

                let movedExtra = 0;

                function getNextMove() {
                    if (lastMove == 0) {
                        nextMove = direction == 'left' ? -5 : 5;
                    } else {
                        nextMove = lastMove * 1.1;
                    }

                    if (direction == 'left') {
                        if ((nextMove * -1) > maxPrFrame) {
                            nextMove = maxPrFrame * -1;
                        }

                        if ((movedExtra + nextMove) < moveExtra) {
                            nextMove = moveExtra - movedExtra;
                        }
                    } else if (direction == 'right') {
                        if (nextMove > maxPrFrame) {
                            nextMove = maxPrFrame;
                        }

                        if ((movedExtra + nextMove) > moveExtra) {
                            nextMove = moveExtra - movedExtra;
                        }
                    }

                    movedExtra = movedExtra + nextMove;
                    lastMove = nextMove;

                    return nextMove;
                }

                if (bounce) {
                    getBounceSteps(bouncePx);
                }

                if (direction == 'left') {
                    while (movedTotal > moveExtra) {
                        nextMove = getNextMove(lastMove);
                        movedTotal = movedTotal + nextMove;

                        animationSteps.push(nextMove);
                    }

                    animationSteps.push(5);
                } else if (direction == 'right') {
                    while (movedTotal < moveExtra) {
                        nextMove = getNextMove(lastMove);
                        movedTotal = movedTotal + nextMove;

                        animationSteps.push(nextMove);
                    }

                    animationSteps.push(-5);
                }

                animationSteps = animationSteps.reverse();

                return animationSteps;
            }

            // Start gallery (at touch start and mousedown)
            function startGallery(e) {
                move = true;
                startTime = new Date();

                if (e.changedTouches) {
                    touch = true;

                    startX = e.changedTouches[0].pageX;
                    startY = e.changedTouches[0].pageY;
                } else {
                    startX = e.clientX;
                    startY = e.clientY;

                    if (e.target.closest('a')) {
                        e.preventDefault();
                    }

                    document.addEventListener('mousemove', documentMouseMove);
                }
            }

            // Move gallery (when swiping and moving mouse)
            function moveGallery(e) {
                if (e.touches) {
                    if (e.touches.length == 1) {
                        move = true;
                        moved = true;

                        moveX = e.targetTouches[0].pageX;
                        moveY = e.targetTouches[0].pageY;
                    }
                } else {
                    moved = true;

                    moveX = e.clientX;
                    moveY = e.clientY;
                }

                if (move) {
                    distanceX = startX - moveX;
                    let distanceY = startY - moveY;

                    direction = startX > moveX ? 'left' : 'right';

                    distanceX = distanceX < 0 ? distanceX * -1 : distanceX;
                    distanceY = distanceY < 0 ? distanceY * -1 : distanceY;

                    if (distanceX > distanceY) {
                        if (e.touches) {
                            e.preventDefault();
                        }

                        moveList();
                    }
                }
            }

            // End gallery (touch end and mouse up)
            function endGallery(e) {
                if (moved) {
                    if (!touch) {
                        document.removeEventListener('mousemove', documentMouseMove);
                    }

                    pxMoved = translateX;

                    endTime = new Date();

                    if (startTime != -1) {
                        time = (endTime.getTime() - startTime.getTime()) / 1000;

                        let pxPrSecond = distanceX / time;
                        pxPrSecond = pxPrSecond >= 0 ? pxPrSecond : pxPrSecond * -1;

                        if (pxPrSecond > maxPxPrSecond) {
                            pxPrSecond = maxPxPrSecond;
                        }

                        if (pxPrSecond > 500) {
                            moveListExtra(pxPrSecond);
                        } else {
                            resetGallery();
                        }
                    } else {
                        resetGallery();
                    }
                }
            }

            // Reset gallery variables
            function resetGallery() {
                if (listAnimation != -1) {
                    cancelAnimationFrame(listAnimation);
                    listAnimation = -1;
                }

                move = false;

                startX = -1;
                startY = -1;

                moveX = -1;
                moveY = -1;

                direction = -1;

                distanceX = -1;

                translateX = -1;

                touch = false;

                startTime = -1;
                endTime = -1;
                time = -1;

                animating = false;

                setTimeout(function() {
                    moved = false;
                }, 50);
            }

            if (progressBar) {
                const progress = progressBar.querySelector('.gallery__slider-bar__progress');
                const maxScale = progressBar.offsetWidth;
                const scalePrPx = maxScale / (minTranslate * -1);

                //progress.setAttribute('data-max-scale',maxScale);
                progress.setAttribute('data-scale-pr-px',scalePrPx);
            }

            // Move list - just when swiping and moving mouse around
            function moveList() {
                translateX = direction == 'left' ? distanceX * -1 : distanceX;

                let newTranslateX = translateX + pxMoved;

                // ---------- RP - start Keflico specfic stuff
                if (newTranslateX <= 0 && newTranslateX >= minTranslate) {
                    if (progressBar) {
                        const progress = progressBar.querySelector('.gallery__slider-bar__progress');
                        const scalePrPx = progress.getAttribute('data-scale-pr-px');
                        const scale = (newTranslateX * -1) * scalePrPx;
                        progress.style.transform = `translateZ(0) scaleX(${scale})`;
                    }
                }
                // ---------- RP - end Keflico specfic stuff

                newTranslateX = newTranslateX > 0 ? 0 : newTranslateX;
                newTranslateX = newTranslateX < minTranslate ? minTranslate : newTranslateX;

                galleryList.style.transform = `translate3d(${newTranslateX}px,0,0)`;

                moved = true;
                translateX = newTranslateX;
            }

            function galleryTransitionEnd() {
                galleryList.style.transition = null;
                galleryList.removeEventListener('transitionend', galleryTransitionEnd);
            }

            // Move list extra if we did it really fast ;-)
            function moveListExtra(pxPrSecond) {
                animating = true;

                let moveExtra = (pxPrSecond / 100000000) * (pxPrSecond * pxPrSecond);

                if (touch) {
                    const _pxPrSecond = pxPrSecond * 2;
                    moveExtra = (_pxPrSecond / 100000000) * (_pxPrSecond * _pxPrSecond);
                }

                if (direction == 'left') {
                    moveExtra = moveExtra * -1;
                }

                let newTranslateX = -1;
                let movedExtra = 0;
                let animationStepIndex = 0;

                const animationSteps = getAnimationSteps(moveExtra);

                function animateList() {
                    if (animationStepIndex + 1 >= animationSteps.length) {
                        if (newTranslateX != -1) {
                            translateX = newTranslateX;
                            pxMoved = translateX;
                        }

                        resetGallery();
                    } else {
                        movedExtra = movedExtra + animationSteps[animationStepIndex];
                        animationStepIndex++;
                        movedExtra = movedExtra;

                        newTranslateX = translateX + movedExtra;
                        galleryList.style.transform = `translate3d(${newTranslateX}px,0,0)`;

                        // ---------- RP - start Keflico specfic stuff
                        if (newTranslateX <= 0 && newTranslateX >= minTranslate) {
                            if (progressBar) {
                                const progress = progressBar.querySelector('.gallery__slider-bar__progress');
                                const scalePrPx = progress.getAttribute('data-scale-pr-px');
                                const scale = (newTranslateX * -1) * scalePrPx;
                                progress.style.transform = `translateZ(0) scaleX(${scale})`;
                            }
                        }
                        // ---------- RP - end Keflico specfic stuff

                        requestAnimationFrame(animateList);
                    }
                }

                listAnimation = requestAnimationFrame(animateList);
            }

            // Events
            function galleryTouchStart(e) {
                if (!animating) {
                    resetGallery();

                    if (e.touches.length == 1) {
                        startGallery(e);
                    }
                }
            }

            function galleryTouchMove(e) {
                if (!animating) {
                    moveGallery(e);
                }
            }

            function galleryTouchEnd(e) {
                if (!animating) {
                    endGallery();
                }
            }

            function galleryTouchCancel(e) {
                if (!animating) {
                    resetGallery();
                }
            }

            function documentMouseUp(e) {
                if (!animating) {
                    endGallery();
                }
            }

            function documentMouseMove(e) {
                if (!animating) {
                    moveGallery(e);
                }
            }

            function galleryMouseDown(e) {
                if (!animating) {
                    resetGallery();
                    startGallery(e);
                }
            }

            galleryWrap.addEventListener('touchstart', galleryTouchStart);
            galleryWrap.addEventListener('touchmove', galleryTouchMove);
            galleryWrap.addEventListener('touchend', galleryTouchEnd);
            galleryWrap.addEventListener('touchcancel', galleryTouchCancel);
            document.addEventListener('mouseup', documentMouseUp);
            galleryWrap.addEventListener('mousedown', galleryMouseDown);
        }
    });
}